import { useEffect, useState } from "react";
import { Feather } from "lucide-react";
import { motion } from "framer-motion";
import { api } from "@/lib/api";
import { useProfile } from "@/context/ProfileContext";

export const BabyNameCard = () => {
  const { profile } = useProfile();
  const [nm, setNm] = useState(null);
  const name = profile?.baby_name;

  useEffect(() => {
    setNm(null);
    if (!profile?.id || !name) return;
    api.get(`/profile/${profile.id}/name-meaning`).then(({ data }) => setNm(data.meaning)).catch(() => {});
  }, [profile?.id, name]);

  if (!name) return null;

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 pt-6 sm:pt-10">
      <motion.div data-testid="baby-name-card" initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}
        className="relative overflow-hidden rounded-3xl border border-[#F0DDD3] bg-[#FBF3EE] px-5 py-5 sm:px-8 sm:py-6 flex gap-4 items-start">
        <div className="shrink-0 w-11 h-11 rounded-2xl bg-white text-[#C87D75] flex items-center justify-center shadow-sm">
          <Feather size={20} />
        </div>
        <div className="min-w-0">
          <div className="text-[11px] uppercase tracking-[0.2em] font-semibold text-[#C87D75]">Il nome di {name}</div>
          <div className="mt-1 flex flex-wrap items-baseline gap-x-3 gap-y-1">
            <h2 className="font-serif text-2xl sm:text-3xl text-[#2D2825]" data-testid="baby-name-title">{name}</h2>
            {nm?.origin && <span className="text-sm text-[#8C7F78] italic" data-testid="baby-name-origin">origine {nm.origin.replace(/^origine\s+/i, "")}</span>}
          </div>
          {nm?.meaning ? (
            <p className="mt-1.5 text-sm sm:text-[15px] text-[#5C534E] leading-relaxed max-w-2xl" data-testid="baby-name-meaning">{nm.meaning}</p>
          ) : !nm && <div className="mt-2 h-4 w-56 max-w-full rounded-full bg-[#F0DDD3]/70 animate-pulse" />}
        </div>
      </motion.div>
    </section>
  );
};
